<script>
    import Typing from './TypingAnimation.svelte';
</script>

<style>
    @keyframes slideInBottom {
        0% {
            transform: translateY(100%);
            opacity: 0;
        }
        100% {
            transform: translateY(0);
            opacity: 1;
        }
    }

    @keyframes slideInLeft {
        0% {
            transform: translateX(-200%);
            opacity: 0;
        }
        10% {
            opacity: 0;
        }
        100% {
            transform: translateX(0);
            opacity: 1;
        }
    }

    @keyframes slideInRight {
        0% {
            transform: translateX(200%);
            opacity: 0;
        }
        10% {
            opacity: 0;
        }
        100% {
            transform: translateX(0);
            opacity: 1;
        }
    }

    .hero-section {
        animation: slideInBottom 1.5s ease forwards;
        background: linear-gradient(135deg, rgba(100, 181, 246, 0.1) 0%, rgba(66, 165, 245, 0.1) 100%);
        border: 1px solid rgba(100, 181, 246, 0.2);
        border-radius: 24px;
        padding: 2rem;
        margin: 1rem auto;
        backdrop-filter: blur(10px);
        max-width: 1400px;
        width: 100%;
        box-sizing: border-box;
    }

    .hero-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 2rem;
        max-width: 1200px;
        margin: 0 auto;
    }

    .hero-text {
        flex: 1;
        animation: slideInLeft 1.5s ease forwards;
        min-width: 0;
    }

    .hero-title {
        font-size: clamp(2.5rem, 5vw, 4rem);
        font-weight: 700;
        margin: 0 0 1rem 0;
        background: linear-gradient(135deg, #64b5f6, #42a5f5);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        line-height: 1.2;
    }

    .hero-description {
        font-size: clamp(1rem, 2vw, 1.3rem);
        line-height: 1.6;
        color: #e0e0e0;
        margin: 0 0 1rem 0;
        font-weight: 400;
        max-width: 600px;
    }

    .hero-image-container {
        flex-shrink: 0;
        animation: slideInRight 1.5s ease forwards;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .hero-image {
        width: clamp(250px, 25vw, 350px);
        height: clamp(250px, 25vw, 350px);
        object-fit: cover;
        border-radius: 20px;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
        transition: transform 0.3s ease;
        border: 3px solid rgba(100, 181, 246, 0.3);
    }

    .hero-image:hover {
        transform: scale(1.05);
    }

    .tech-note {
        background: rgba(100, 181, 246, 0.1);
        border: 1px solid rgba(100, 181, 246, 0.3);
        border-radius: 12px;
        padding: 1rem 1.5rem;
        margin-top: 2rem;
        font-size: 0.9rem;
        color: #b0b0b0;
        max-width: 600px;
    }

    .tech-note a {
        color: #64b5f6;
        text-decoration: none;
        font-weight: 500;
        transition: color 0.3s ease;
    }

    .tech-note a:hover {
        color: #90caf9;
    }

    .contact-info {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 1rem;
        margin-top: 1rem;
        font-size: 0.9rem;
        color: #b0b0b0;
    }

    .contact-item {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.5rem;
        border-radius: 8px;
        transition: background-color 0.3s ease;
    }

    .contact-item:hover {
        background: rgba(100, 181, 246, 0.1);
    }

    .contact-item a {
        color: #64b5f6;
        text-decoration: none;
        transition: color 0.3s ease;
    }

    .contact-item a:hover {
        color: #90caf9;
    }

    /* Tablet and smaller screens */
    @media only screen and (max-width: 1024px) {
        .hero-section {
            padding: 2.5rem;
            margin: 1.5rem auto;
        }

        .hero-content {
            gap: 2rem;
        }

        .hero-image {
            width: clamp(200px, 20vw, 280px);
            height: clamp(200px, 20vw, 280px);
        }
    }

    /* Mobile screens */
    @media only screen and (max-width: 768px) {
        .hero-section {
            padding: 2rem;
            margin: 1rem auto;
        }

        .hero-content {
            flex-direction: column;
            text-align: center;
            gap: 2rem;
        }

        .hero-text {
            animation: slideInBottom 1.5s ease forwards;
            order: 2;
        }

        .hero-image-container {
            animation: slideInBottom 1.5s ease forwards;
            order: 1;
        }

        .hero-image {
            width: 250px;
            height: 250px;
        }

        .contact-info {
            grid-template-columns: 1fr;
            gap: 0.75rem;
        }

        .contact-item {
            justify-content: center;
        }
    }

    /* Small mobile screens */
    @media only screen and (max-width: 480px) {
        .hero-section {
            padding: 1.5rem;
            margin: 0.5rem auto;
        }

        .hero-image {
            width: 200px;
            height: 200px;
        }

        .contact-info {
            font-size: 0.8rem;
        }
    }

    /* Large screens */
    @media only screen and (min-width: 1400px) {
        .hero-section {
            padding: 4rem;
        }

        .hero-content {
            gap: 4rem;
        }
    }

    /* Ultra-wide screens */
    @media only screen and (min-width: 1920px) {
        .hero-section {
            max-width: 1600px;
        }

        .hero-content {
            max-width: 1400px;
        }
    }
</style>

<section class="hero-section">
    <div class="hero-content">
        <div class="hero-text">
            <h1 class="hero-title"><Typing/></h1>
            <p class="hero-description">
                I'm a Computer Science undergraduate at the University of Maryland, College Park. 4.0 GPA and Dean's List recognized. As President of ACM@UMD and Linux Club@UMD, 
                I've grown the ACM from 50 to 200+ members through technical workshops and community building. 
                I'm currently conducting research at Belta Research Group, implementing machine learning 
                models for robotic decision-making. Beyond programming, I enjoy nature photography, 
                skating, and spending time with my dog.
            </p>
        </div>
        <div class="hero-image-container">
            <img src="/assets/self-portrait-close.jpg" alt="Joshua Zheng" class="hero-image" />
        </div>
    </div>
</section>

